/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'user-circle': {
    width: 24,
    height: 24,
    viewBox: '0 0 24 24',
    data: '<path pid="0" d="M5.121 17.804A13.937 13.937 0 0 1 12 16c2.5 0 4.847.655 6.879 1.804M15 10a3 3 0 1 1-6 0 3 3 0 0 1 6 0zm6 2a9 9 0 1 1-18 0 9 9 0 0 1 18 0z" _stroke="#4A5568" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>'
  }
})
